import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadGroupItemTemplate: IGroupItemTemplateLoadActionCreator = (groupId) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_LOAD,
            groupId
        }
    },
    LoadGroupItemTemplateById: IGroupItemTemplateLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IGroupItemTemplateLoadSuccessActionCreator = (formData, formDataGrouped, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_LOAD_SUCCESS,
            formData,
            formDataGrouped,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IGroupItemTemplateLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveGroupItemTemplate: IGroupItemTemplateSaveActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_SAVE,
            formData,
            collectionFormData
        }
    },
    SaveSuccess: IGroupItemTemplateSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IGroupItemTemplateSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateGroupItemTemplate: IGroupItemTemplateCreateActionCreator = (groupId) => {

        return {
            type: ACTION_GROUPITEMTEMPLATE_CREATE,
            groupId
        }
    },
    CreateSuccess: IGroupItemTemplateCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IGroupItemTemplateCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateGroupItemTemplate: IGroupItemTemplateValidateActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_VALIDATE,
            formData,
            collectionFormData
        }
    },
    ValidateSuccess: IGroupItemTemplateValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IGroupItemTemplateValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IGroupItemTemplateClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_GROUPITEMTEMPLATE_CLEAR,
            propertiesToClear
        }
    },
    Filter: IGroupItemTemplateFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_GROUPITEMTEMPLATES_FILTER,
            formFilter
        }
    };



export const
    ACTION_GROUPITEMTEMPLATE_LOAD = "ACTION_GROUPITEMTEMPLATE_LOAD",
    ACTION_GROUPITEMTEMPLATE_LOAD_BY_ID = "ACTION_GROUPITEMTEMPLATE_LOAD_BY_ID",
    ACTION_GROUPITEMTEMPLATE_LOAD_SUCCESS = "ACTION_GROUPITEMTEMPLATE_LOAD_SUCCESS",
    ACTION_GROUPITEMTEMPLATE_LOAD_FAILURE = "ACTION_GROUPITEMTEMPLATE_LOAD_FAILURE",

    ACTION_GROUPITEMTEMPLATE_SAVE = "ACTION_GROUPITEMTEMPLATE_SAVE",
    ACTION_GROUPITEMTEMPLATE_SAVE_SUCCESS = "ACTION_GROUPITEMTEMPLATE_SAVE_SUCCESS",
    ACTION_GROUPITEMTEMPLATE_SAVE_FAILURE = "ACTION_GROUPITEMTEMPLATE_SAVE_FAILURE",

    ACTION_GROUPITEMTEMPLATE_CREATE = "ACTION_GROUPITEMTEMPLATE_CREATE",
    ACTION_GROUPITEMTEMPLATE_CREATE_SUCCESS = "ACTION_GROUPITEMTEMPLATE_CREATE_SUCCESS",
    ACTION_GROUPITEMTEMPLATE_CREATE_FAILURE = "ACTION_GROUPITEMTEMPLATE_CREATE_FAILURE",

    ACTION_GROUPITEMTEMPLATE_VALIDATE = "ACTION_GROUPITEMTEMPLATE_VALIDATE",
    ACTION_GROUPITEMTEMPLATE_VALIDATE_SUCCESS = "ACTION_GROUPITEMTEMPLATE_VALIDATE_SUCCESS",
    ACTION_GROUPITEMTEMPLATE_VALIDATE_FAILURE = "ACTION_GROUPITEMTEMPLATE_VALIDATE_FAILURE",

    ACTION_GROUPITEMTEMPLATE_CLEAR = "ACTION_GROUPITEMTEMPLATE_CLEAR",
    ACTION_GROUPITEMTEMPLATES_FILTER = "ACTION_GROUPITEMTEMPLATES_FILTER";

export interface IGroupItemTemplateLoadAction {
    type: "ACTION_GROUPITEMTEMPLATE_LOAD";
    groupId: number;
}

export interface IGroupItemTemplateLoadActionCreator {
    (groupId?: number): IGroupItemTemplateLoadAction;
}

export interface IGroupItemTemplateLoadSuccessAction {
    type: "ACTION_GROUPITEMTEMPLATE_LOAD_SUCCESS";
    formData: Dtos.GroupItemTemplate | Dtos.GroupItemTemplate[];
    formDataGrouped: Dtos.GroupItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemTemplateLoadSuccessActionCreator {
    (
        formData: Dtos.GroupItemTemplate | Dtos.GroupItemTemplate[],
        formDataGrouped: Dtos.GroupItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupItemTemplateLoadSuccessAction;
}

export interface IGroupItemTemplateLoadFailureAction {
    type: "ACTION_GROUPITEMTEMPLATE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemTemplateLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemTemplateLoadFailureAction;
}

export interface IGroupItemTemplateLoadByIdAction {
    type: "ACTION_GROUPITEMTEMPLATE_LOAD_BY_ID";
    id: number;
}

export interface IGroupItemTemplateLoadByIdActionCreator {
    (id: number): IGroupItemTemplateLoadByIdAction;
}

export interface IGroupItemTemplateSaveAction {
    type: "ACTION_GROUPITEMTEMPLATE_SAVE";
    formData: Dtos.GroupItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface IGroupItemTemplateSaveActionCreator {
    (
        formData: Dtos.GroupItemTemplate,
        collectionFormData: Dtos.Collection
    ): IGroupItemTemplateSaveAction;
}

export interface IGroupItemTemplateSaveSuccessAction {
    type: "ACTION_GROUPITEMTEMPLATE_SAVE_SUCCESS";
    formData: Dtos.GroupItemTemplate;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemTemplateSaveSuccessActionCreator {
    (
        formData: Dtos.GroupItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupItemTemplateSaveSuccessAction;
}

export interface IGroupItemTemplateSaveFailureAction {
    type: "ACTION_GROUPITEMTEMPLATE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupItemTemplateSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemTemplateSaveFailureAction;
}

export interface IGroupItemTemplateCreateAction {
    type: "ACTION_GROUPITEMTEMPLATE_CREATE";
    groupId: number;
}

export interface IGroupItemTemplateCreateActionCreator {
    (groupId?: number): IGroupItemTemplateCreateAction
}

export interface IGroupItemTemplateCreateSuccessAction {
    type: "ACTION_GROUPITEMTEMPLATE_CREATE_SUCCESS";
    formData: Dtos.GroupItemTemplate;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IGroupItemTemplateCreateSuccessActionCreator {
    (
        formData: Dtos.GroupItemTemplate,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IGroupItemTemplateCreateSuccessAction;
}

export interface IGroupItemTemplateCreateFailureAction {
    type: "ACTION_GROUPITEMTEMPLATE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupItemTemplateCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemTemplateCreateFailureAction;
}

export interface IGroupItemTemplateValidateAction {
    type: "ACTION_GROUPITEMTEMPLATE_VALIDATE";
    formData: Dtos.GroupItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface IGroupItemTemplateValidateActionCreator {
    (
        formData: Dtos.GroupItemTemplate,
        collectionFormData: Dtos.Collection
    ): IGroupItemTemplateValidateAction;
}

export interface IGroupItemTemplateValidateSuccessAction {
    type: "ACTION_GROUPITEMTEMPLATE_VALIDATE_SUCCESS";
    formData: Dtos.GroupItemTemplate;
    formState: Dtos.FormState;
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemTemplateValidateSuccessActionCreator {
    (
        formData: Dtos.GroupItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupItemTemplateValidateSuccessAction;
}

export interface IGroupItemTemplateValidateFailureAction {
    type: "ACTION_GROUPITEMTEMPLATE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupItemTemplateValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemTemplateValidateFailureAction;
}

export interface IGroupItemTemplateClearAction {
    type: "ACTION_GROUPITEMTEMPLATE_CLEAR";
    propertiesToClear?: string[];
}

export interface IGroupItemTemplateClearActionCreator {
    (propertiesToClear?: string[]): IGroupItemTemplateClearAction;
}

export interface IGroupItemTemplateFilterActionCreator {
    (formFilter: IFormFilter): IGroupItemTemplateFilterAction;
}

export interface IGroupItemTemplateFilterAction {
    type: "ACTION_GROUPITEMTEMPLATES_FILTER";
    formFilter: IFormFilter;
}

export type GroupItemTemplateAction =
    IGroupItemTemplateLoadAction |
    IGroupItemTemplateLoadByIdAction |
    IGroupItemTemplateLoadFailureAction |
    IGroupItemTemplateLoadSuccessAction |
    IGroupItemTemplateSaveAction |
    IGroupItemTemplateSaveSuccessAction |
    IGroupItemTemplateSaveFailureAction |
    IGroupItemTemplateCreateAction |
    IGroupItemTemplateCreateSuccessAction |
    IGroupItemTemplateCreateFailureAction |
    IGroupItemTemplateValidateAction |
    IGroupItemTemplateValidateSuccessAction |
    IGroupItemTemplateValidateFailureAction |
    IGroupItemTemplateClearAction |
    IGroupItemTemplateFilterAction;
